import C from 'classnames';
import * as React from 'react';
import { Link } from 'react-router-dom';
export const DropdownItem = (props) => {
    const [dropdownItemJSX, setDropdownItemJSX] = React.useState(null);
    React.useEffect(() => {
        setDropdownItemJSX(props.to ? (React.createElement(Link, { to: props.to, key: props.value, className: C('dropdown-item', props.className, props.disabled && 'disabled'), onClick: (e) => {
                props.toggle();
                props.onClick && props.onClick(props.value, e);
            }, onMouseDown: (e) => props.onMouseDown && props.onMouseDown(props.value, e) }, props.children)) : props.href ? (React.createElement("a", { href: props.href, download: props.download, key: props.value, className: C('dropdown-item', props.className, props.disabled && 'disabled'), onClick: (e) => {
                props.toggle();
                props.onClick(props.value, e);
            }, onMouseDown: (e) => props.onMouseDown && props.onMouseDown(props.value, e) }, props.children)) : (React.createElement("button", { key: props.value, className: C('dropdown-item', props.className, props.disabled && 'disabled'), onClick: (e) => {
                props.toggle();
                props.onClick(props.value, e);
            }, onMouseDown: (e) => props.onMouseDown && props.onMouseDown(props.value, e) }, props.children)));
    }, [props]);
    return props.WrapperComponent
        ? React.cloneElement(props.WrapperComponent, null, dropdownItemJSX)
        : dropdownItemJSX;
};
//# sourceMappingURL=DropdownItem.js.map